var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFirstAid = function SvgIconFirstAid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.513 2.513A1.75 1.75 0 0 1 9.75 2h4.5A1.75 1.75 0 0 1 16 3.75V8h4.25A1.75 1.75 0 0 1 22 9.75v4.5A1.75 1.75 0 0 1 20.25 16H16v4.25A1.75 1.75 0 0 1 14.25 22h-4.5A1.75 1.75 0 0 1 8 20.25V16H3.75A1.75 1.75 0 0 1 2 14.25v-4.5A1.75 1.75 0 0 1 3.75 8H8V3.75c0-.464.184-.91.513-1.237M10 4v5a1 1 0 0 1-1 1H4v4h5a1 1 0 0 1 1 1v5h4v-5a1 1 0 0 1 1-1h5v-4h-5a1 1 0 0 1-1-1V4z",
    clipRule: "evenodd"
  })));
};
export default SvgIconFirstAid;